import React, { useState } from 'react';
import './MessageActions.css';

interface MessageActionsProps {
  answerContent: string; // El HTML de la respuesta para copiar/imprimir
  onRate: (rating: 'good' | 'bad') => Promise<boolean>; // Función que manejará la llamada a la API
}

const MessageActions: React.FC<MessageActionsProps> = ({ answerContent, onRate }) => {
  const [ratedAs, setRatedAs] = useState<'good' | 'bad' | null>(null);
  const [copyStatus, setCopyStatus] = useState('Copiar');

  const handleCopy = () => {
    // Para copiar el contenido sin las etiquetas HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = answerContent;
    const textToCopy = tempDiv.textContent || tempDiv.innerText || "";

    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopyStatus('¡Copiado!');
      setTimeout(() => setCopyStatus('Copiar'), 2000);
    }).catch(err => {
      console.error('Error al copiar:', err);
      setCopyStatus('Error');
      setTimeout(() => setCopyStatus('Copiar'), 2000);
    });
  };

  const handlePrint = () => {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      // Incluimos algunos estilos básicos para una mejor impresión
      doc.write(`
        <html>
          <head>
            <title>Imprimir Respuesta</title>
            <style>
              body { font-family: sans-serif; line-height: 1.5; }
              h1, h2, h3 { color: #333; }
              table { border-collapse: collapse; width: 100%; margin-bottom: 1rem; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            ${answerContent}
          </body>
        </html>
      `);
      doc.close();
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    }
    
    // Limpiamos el iframe después de un tiempo
    setTimeout(() => document.body.removeChild(iframe), 1000);
  };

  const handleRatingClick = async (rating: 'good' | 'bad') => {
    if (ratedAs) return; // No permitir calificar de nuevo

    const success = await onRate(rating);
    if (success) {
      setRatedAs(rating);
    }
  };

  return (
    <div className="message-actions">
      <button title={copyStatus} onClick={handleCopy}>📋</button>
      <button title="Imprimir" onClick={handlePrint}>🖨️</button>
      
      <div className="rating-actions">
        <button 
          title="Respuesta útil" 
          onClick={() => handleRatingClick('good')}
          className={ratedAs === 'good' ? 'selected' : ''}
          disabled={!!ratedAs}
        >
          👍
        </button>
        <button 
          title="Respuesta no útil" 
          onClick={() => handleRatingClick('bad')}
          className={ratedAs === 'bad' ? 'selected' : ''}
          disabled={!!ratedAs}
        >
          👎
        </button>
      </div>
    </div>
  );
};

export default MessageActions;